import { useMemo } from 'react';

import { Flex, Progress } from 'antd';

import { Text, Title } from 'components/mvp-typography';
import { addDays, format } from 'date-fns';
import { sortBy } from 'lodash';
import { usePatientInfoContext } from '../../../_utils/patient-info/hook-context-patientinfo';

export function AdministrationSchedule() {
  const patientInfo = usePatientInfoContext();

  const sortedAssessments = useMemo(
    () => sortBy(patientInfo.patientInfo.dhi, _ => _.date.unix()) ?? [],
    [patientInfo]
  );

  const nextAssessment = addDays(
    sortedAssessments.at(-1)?.date.toDate() ?? Date.now(),
    30
  );

  return (
    <div>
      <Flex gap={'large'} vertical>
        <div>
          <Title level={2}>Assessment schedule</Title>
          <Text>
            An overview of the test-takers past and upcoming assessments.
          </Text>
        </div>
        <Flex gap={'large'} wrap>
          <Flex justify="center" align="center" vertical>
            <Progress
              type="dashboard"
              format={value => `${Math.round(((value ?? 0) / 100) * 3)}/3`}
              percent={(sortedAssessments.length / 3) * 100}
            />

            <Text>assessments completed</Text>
          </Flex>
          <div
            style={{
              margin: '10px 0rem 10px 0rem',
              background: 'red',
              borderRight: '1px solid gray'
            }}
          />

          <div>
            <div>
              <Flex gap={'large'}>
                <Text style={{ fontWeight: 'bold' }}>Next assessment:</Text>
                <Text>{format(nextAssessment, 'yyyy-MM-dd')}</Text>
              </Flex>
            </div>
            <div>
              <Text>Assessment history</Text>
              <ol>
                {sortedAssessments.map((_, i) => (
                  <li key={i}>{format(_.date.toDate(), 'yyyy-MM-dd')}</li>
                ))}
              </ol>
            </div>
          </div>
        </Flex>
      </Flex>
    </div>
  );
}
